import Menu from './Compartido/Menu.jsx';
import TextosLegal from './Legal/TextosLegal.jsx';
import Footer from './Compartido/Footer.jsx';

const Legal = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosLegal
                ruta={props.ruta}
                legal={props.textoavisolegal}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Legal;
